import DirectDebitBecsHeader from './direct-debit-becs-header';

export default DirectDebitBecsHeader;
